import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=3523b21a&scoped=true&lang=pug"
import script from "./Mapa.vue?vue&type=script&lang=js"
export * from "./Mapa.vue?vue&type=script&lang=js"
import style0 from "./Mapa.vue?vue&type=style&index=0&id=3523b21a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523b21a",
  null
  
)

export default component.exports